import { extensionEditorStyles } from '@bingads-webui-campaign-react/common-styles';

export const getVideoEditorStyles = (_, { palette = {} }) => ({
  header: {
    display: 'absolute', // remove the header from original rendering flow
    height: '60px',
  },
  videoEditor: {
    '& .ms-Panel-contentInner': {
      height: '100%',
      '& .ms-Panel-scrollableContent': {
        overflowY: 'hidden',
        height: '100%',
        '& .ms-Panel-content': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          paddingLeft: '0px',
          paddingRight: '0px',
          paddingBottom: '0px',
        },
      },
    },
    '& .ms-Panel-commands': {
      position: 'absolute',
      width: '100%',
      background: 'transparent',
      '& .ms-Panel-header': {
        paddingLeft: '32px',
      },
    },
    '& $top': {
      '& $leftPanel': {
        '& $leftPanelTop': {
        },
        '& $leftPanelMiddle': {
          '& $tabs': {
          },
          '& $metadata': {
          },
        },
        '& $leftPanelBottom': {
        },
      },
      '& $rightPanel': {
      },
    },
    '& $bottom': {
    },
  },
  leftPanelTop: {
    height: '60px',
    flexShrink: 0,
  },
  leftPanelMiddle: {
    marginLeft: '28px',
    display: 'flex',
    flexGrow: 1,
    maxHeight: 'calc(100% - 60px)',
    overflowY: 'auto',
  },
  tabs: {
    width: '102px',
    paddingRight: '16px',
    borderRight: '1px solid #DFDFDF',
    boxSizing: 'content-box',
    paddingLeft: '4px',
  },
  videoSettings: {
    '& .item-title': {
      marginBottom: '8px',
      '& span': {
        fontWeight: 600,
      },
    },
    '& .video-settings-content': {
      width: 102,
      height: 60,
      border: '1px solid #d1d1d1',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '16px',
      '& .icon': {
        fontSize: 18,
        color: '#242424',
      },
      '&.selected': {
        outlineColor: '#0078d4',
        outlineStyle: 'solid',
      },
    },

  },
  metadata: {
    width: '432px',
    paddingLeft: '16px',
    display: 'none',
    '&.selected': {
      display: 'block',
    },
  },
  leftPanelBottom: {
    height: '24px',
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    width: '600px',
  },
  rightPanel: {
    width: '675px',
    paddingLeft: '32px',
    paddingRight: '32px',
    borderLeft: '1px solid #DFDFDF',
    backgroundColor: palette.neutralLighterAlt || '#FAF9F8',
    paddingTop: '52px',
  },
  top: {
    flexGrow: 1,
    display: 'flex',
    maxHeight: 'calc(100% - 64px)',
  },
  bottom: {
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    borderTop: '1px solid #DFDFDF',
    paddingLeft: '32px',
    flexShrink: 0,
    '& .apply-button': {
      marginRight: '8px',
    },
  },
});

export const getGlobalLogoPickerStyles = (_, { palette = {} }) => ({
  '@global': {
    ...extensionEditorStyles({ palette }),
  },
});
